import React, { Component } from "react";
import { connect } from "react-redux";
import uuidv4 from "uuid/v4";
import {
  Alert,
  Form,
  Label,
  Row,
  Input,
  FormGroup,
  ButtonGroup,
  Button,
  Card,
  CardBody,
  CardHeader,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import Select from 'react-select';
import classNames from "classnames";
import { hasError, textValue } from "../../utils/form";
import UploadImages from "./FaqImages/UploadImages";

import {
  createFaq,
  deleteFaq,
  getDetailFaq,
  updateFaq,
  addImage,
  deleteImage,
} from "../../actions/faqAction";
import {
  clearImageUpload,
  uploadImage,
  deleteImage as deleteImageS3,
} from "../../actions/imageUploadAction";
import {
  IMAGE_ACCEPT,
  IMAGE_UPLOAD_ERROR_MESSAGE,
  ImagesCompressor,
  createUploadFileForm,
  hasUnsupportedImageFiles,
} from "../../utils/imageHelper";
import { ValidationMessage } from "../../components/Form/ValidationMessage";
import { AWS_BUCKET_FAQ, AWS_BUCKET_REGION } from "../../config/storageBucket";
import { getPathS3, getOriginFromSignedUrl } from "../../utils/AWS";
import Analytics from "../../services/Analytics";
import FaqImages from "./FaqImages";
import RichTextEditor from "../../components/Form/RichTextEditor";
import FaqCategoryIndex from "./Category/FaqCategoryIndex";
import SelectFaqCategory from "../../components/Form/Select/Async/SelectFaqCategory";

const AWS_ENDPOINT = "amazonaws.com";
const languageOptions = [{
  value: "ind", label: "Indonesia"
},{
  value: "eng", label: "English"
}];


const getStorageName = (imgUrl) => {
  if (new RegExp(AWS_BUCKET_FAQ).test(imgUrl)) return AWS_BUCKET_FAQ;
  else if (/ka-faq-assets/.test(imgUrl)) return "ka-faq-assets";
  return "external-link";
};

const getUrlKey = (imgUrl) => {
  const regexStorage = new RegExp(AWS_BUCKET_FAQ);
  if (regexStorage.test(imgUrl)) {
    const firstPattern = new RegExp(
      `s3.${AWS_BUCKET_REGION}.${AWS_ENDPOINT}/${AWS_BUCKET_FAQ}/`
    );
    const secondPattern = new RegExp(
      `${AWS_BUCKET_FAQ}.s3.${AWS_BUCKET_REGION}.${AWS_ENDPOINT}/`
    );
    const thirdPattern = new RegExp(`${AWS_BUCKET_FAQ}.s3.${AWS_ENDPOINT}/`);
    let parsedUrl = imgUrl.trim().replace(/^(https|http):\/\//, "");
    if (firstPattern.test(parsedUrl)) {
      return parsedUrl.replace(firstPattern, "");
    } else if (secondPattern.test(parsedUrl)) {
      return parsedUrl.replace(secondPattern, "");
    } else if (thirdPattern.test(parsedUrl)) {
      return parsedUrl.replace(thirdPattern, "");
    }
  }
  return "";
};

const ModalProgress = (props) => (
  <Modal size="sm" className="modal-confirmation" isOpen={props.isOpen}>
    <ModalHeader className="modal-header--center">
      {props.isDeleting ? "Deleting Progress" : "Submitting Progress."}
    </ModalHeader>
    <ModalBody>
      {props.renderModalBody ? props.renderModalBody() : props.modalBody}
    </ModalBody>
    <ModalFooter>
      <Button
        className={classNames({ "d-none": props.isPrimaryButtonHide })}
        color="primary"
        onClick={props.onPrimaryClick}
      >
        Gotchas
      </Button>
    </ModalFooter>
  </Modal>
);

class FaqForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _edit: this.props.edit,
      _readOnly: this.props.readOnly,
      _hasId: this.props.match.params.id ? true : false,
      _images: [],
      _form: {
        binding: false,
        id: this.props.match.params.id,
        question: "",
        language: null,
        language_code: "ind",
        answer: "",
        faq_category: null,
        faq_category_id: "",
        details: "",
        active: false,
        created_at: "",
        updated_at: "",
      },
      _imageUploadList: [],
      _formSubmit: false,
      _isDeleting: false,
      _modalDelete: false,
      _modalDeleteProgressOpen: false,
      _faqDeleteProgress: false,
      _isModalProgress: false,
      _taskAvailable: 0,
      _taskDone: 0,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.handleCheckedChange = this.handleCheckedChange.bind(this);
    this.handleChangeEditor = this.handleChangeEditor.bind(this);
    this._handleDropzoneOnDrop = this._handleDropzoneOnDrop.bind(this);
    this._handleRemoveImage = this._handleRemoveImage.bind(this);
    this._handleUploadImages = this._handleUploadImages.bind(this);
  }

  componentDidMount() {
    let pageSlug = "faq_create";
    if (this.state._hasId) {
      this.props.find(this.state._form.id);
      pageSlug = "faq_update";
    }
    const { email } = this.props.injectedProps;
    Analytics.recordPageView(pageSlug, email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match,
    });
  }

  componentWillUnmount() {
    this.props.clearImageUpload();
  }

  componentDidUpdate = async (lastProps) => {
    const { detail, isFetch, isSubmit, error } = this.props.faq;
    // Edit Form
    if (this.state._edit && this.state._hasId) {
      if (
        lastProps.faq.isSubmittingImage &&
        !this.props.faq.isSubmittingImage
      ) {
        const _images = [...this.state._images];
        const { addedImages } = this.props.faq;
        Object.keys(addedImages).map((index) => {
          const filtered = _images.filter((item) => item.identifier === index);
          if (filtered.length) {
            filtered[0].id = addedImages[index].id;
            filtered[0].url = addedImages[index].URL;
            filtered[0].updated_at = addedImages[index].updated_at;
          }
        });
        this.setState({ _images });
      }

      if (detail.status_code === 200 && error === null) {
        if (!isFetch && !this.state._form.binding) {
          const _images = this.bindFaqImageData(detail.images);
          const _newForm = {
            ...this.state._form,
            ...detail,
            faq_category: {
              id: detail.category.id,
              name: detail.category.name,
            },
            binding: true,
          };
          this.setState({
            _images,
            _form: _newForm,
          });
        }
      }

      // After get detail FAQ
      if (isSubmit !== lastProps.faq.isSubmit) {
        if (this.state._faqDeleteProgress) {
          if (error) {
            this.setState({
              _modalDeleteProgressOpen: false,
              _faqDeleteProgress: false,
            });
          } else if (detail.delete) {
            const { _taskAvailable, _taskDone } = this.state;
            this.setState(
              {
                _delete: detail.delete,
                _faqDeleteProgress: _taskAvailable > _taskDone + 1,
                _taskDone: _taskDone + 1,
              },
              () => {
                const { _assetsToDelete, _faqDeleteProgress } = this.state;
                if (_faqDeleteProgress && _assetsToDelete.length) {
                  const { identifier, url } = _assetsToDelete[0];
                  const payload = {
                    identifier,
                    bucket_type: "faq_assets",
                    name: getPathS3(getOriginFromSignedUrl(url)),
                  };
                  this.props.deleteImageS3(payload);
                }
              }
            );
          }
        }
      }
      if (this.props.imageUpload.isDeleteProgress !==
          lastProps.imageUpload.isDeleteProgress
      ) {
        const { deleted } = this.props.imageUpload;
        //&& this.state._delete === true
        if (this.state._faqDeleteProgress && deleted) {
          const _assetsToDelete = this.state._assetsToDelete.filter(
            ({ identifier }) => identifier !== deleted.identifier
          );
          let _taskDone = this.state._taskDone + 1;
          this.setState(
            {
              _faqDeleteProgress: this.state._taskAvailable > _taskDone,
              _taskDone: _taskDone,
              _assetsToDelete,
            },
            () => {
              const { _assetsToDelete, _faqDeleteProgress } = this.state;
              if (_faqDeleteProgress && _assetsToDelete.length) {
                const { identifier, url } = _assetsToDelete[0];
                const payload = {
                  identifier,
                  bucket_type: "faq_assets",
                  name: getPathS3(getOriginFromSignedUrl(url)),
                };
                this.props.deleteImageS3(payload);
              }
            }
          );
        }
      }
      if (
        !this.props.imageUpload.isUpload &&
        this.props.imageUpload.isUpload !== lastProps.imageUpload.isUpload
      ) {
        const { success, error } = this.props.imageUpload;
        if (!error) {
          const { _images, _imageUploadList } = this.state;
          let myIdentifier = null;
          const filtered = _images.filter(
            (img) =>
              img.identifier === success.data.identifier &&
              !img.status &&
              success.data.url !== null
          );
          if (filtered.length) {
            let { _imageUploadProgress } = this.state;
            myIdentifier = filtered[0].identifier;
            const imageUploadList = _imageUploadList.filter(
              (id) => id !== myIdentifier
            );
            let nextUploadId = null;
            if (imageUploadList.length <= 0) {
              _imageUploadProgress = false;
            } else {
              nextUploadId = imageUploadList[0];
            }
            this.setState(
              {
                _images: _images.map((item) => {
                  if (item.identifier == myIdentifier) {
                    return {
                      ...item,
                      status: true,
                      is_uploading: false,
                      storageName: getStorageName(success.data.url),
                      urlKey: getUrlKey(success.data.url),
                      url: success.data.url,
                    };
                  } else if (item.identifier == nextUploadId) {
                    return {
                      ...item,
                      is_uploading: true,
                    };
                  }
                  return item;
                }),
                _imageUploadList: imageUploadList,
                _imageUploadProgress,
              },
              async () => {
                this.props.saveImage(myIdentifier, {
                  faq_id: this.state._form.id,
                  URL: success.data.url,
                  position:
                    filtered[0].positionEdit !== undefined
                      ? filtered[0].positionEdit
                      : filtered[0].position,
                });
                const nextItemUpload = _images.filter(
                  (item) => item.identifier === nextUploadId
                );
                if (nextItemUpload.length && nextUploadId !== null) {
                  let { identifier, fileInput } = nextItemUpload[0];

                  try {
                    //compress file
                    fileInput = await ImagesCompressor(fileInput);
                  } catch (e) {}
                  const tempPayload = createUploadFileForm(fileInput, false, {
                    name: "faqs/" + this.state._form.id,
                    bucket_type: "faq_assets",
                  });
                  this.props.uploadImage(tempPayload, nextItemUpload[0]);
                }
              }
            );
          }
        }
      }
      // After deleting image's url from kick api
      if (!this.props.faq.isDeletingImage && lastProps.faq.isDeletingImage) {
        const { deletedImages } = this.props.faq;
        if (deletedImages.length) {
          const _images = [...this.state._images];
          const lastUniqueID = deletedImages[deletedImages.length - 1];
          const lastImage = _images.filter(
            (item) => item.identifier === lastUniqueID
          );
          if (lastImage.length) {
            const { identifier, urlKey, url } = lastImage[0];
            if (urlKey !== "") {
              const payload = {
                identifier,
                bucket_type: "faq_assets",
                name: getPathS3(getOriginFromSignedUrl(url)),
              };
              this.props.deleteImageS3(payload);
            }
            this.setState({
              _images: _images.filter(
                (item) => item.identifier !== lastUniqueID
              ),
            });
          }
        }
      }
    }
    // Create Form
    else {
      if (
        lastProps.faq.isSubmit &&
        lastProps.faq.isSubmit !== this.props.faq.isSubmit
      ) {
        if (error === null && detail.status_code === 200) {
          if (!this.state._imageUploadList.length) {
            this.props.history.replace(`/faqs`);
          } else {
            const { _imageUploadList } = this.state;
            if (_imageUploadList.length) {
              let { identifier, fileInput } = _imageUploadList[0];
              //compress file
              try {
                fileInput = await ImagesCompressor(fileInput);
              } catch (e) {}

              const _images = this.state._images.map((item) => {
                if (item.identifier === identifier)
                  return { ...item, isUploading: true };
                return item;
              });
              this.setState(
                {
                  _images,
                  _taskDone: this.state._taskDone + 1,
                  _form: {
                    ...this.state._form,
                    id: detail.id,
                  },
                },
                () => {
                  const tempPayload = createUploadFileForm(fileInput, false, {
                    name: "faqs/" + this.state._form.id,
                    bucket_type: "faq_assets",
                  });
                  this.props.uploadImage(tempPayload, _imageUploadList[0]);
                }
              );
            }
          }
        } else {
          this.setState({
            _isModalProgress: false,
            _taskAvailable: 0,
            _taskDone: false,
          });
        }
      }
      if (
        lastProps.imageUpload.isUpload &&
        lastProps.imageUpload.isUpload !== this.props.imageUpload.isUpload
      ) {
        const { success, error } = this.props.imageUpload;
        if (!error) {
          const { _images } = this.state;
          let myIdentifier = null;
          const filtered = _images.filter(
            (img) =>
              img.identifier === success.data.identifier &&
              !img.status &&
              success.data.url !== null
          );
          if (filtered.length) {
            myIdentifier = filtered[0].identifier;
            this.setState(
              {
                _images: _images.map((item) => {
                  if (item.identifier == myIdentifier) {
                    return {
                      ...item,
                      storageName: getStorageName(success.data.url),
                      urlKey: getUrlKey(success.data.url),
                      url: success.data.url,
                    };
                  }
                  return item;
                }),
              },
              () => {
                this.props.saveImage(myIdentifier, {
                  faq_id: this.state._form.id,
                  URL: success.data.url,
                });
              }
            );
          }
        }
      }
      if (
        lastProps.faq.isSubmittingImage &&
        !this.props.faq.isSubmittingImage
      ) {
        const _images = [...this.state._images];
        const { addedImages } = this.props.faq;
        let getIdentifier = null;
        let count = this.state._taskDone;
        Object.keys(addedImages).map((index) => {
          const filtered = _images.filter(
            (item) => item.identifier === index && item.isUploading
          );
          if (filtered.length) {
            getIdentifier = index;
            filtered[0].id = addedImages[index].id;
            filtered[0].updatedAt = addedImages[index].updated_at;
            filtered[0].status = true;
            filtered[0].isUploading = false;
            count++;
          }
        });
        const nextImageUpload = this.state._imageUploadList.filter(
          (item) => item.identifier !== getIdentifier
        );
        if (nextImageUpload.length) {
          let { identifier, fileInput } = nextImageUpload[0];

          //compress file
          try {
            fileInput = await ImagesCompressor(fileInput);
          } catch (e) {}

          _images.map((item) => {
            if (item.identifier === identifier) {
              item.isUploading = true;
            }
          });
          const tempPayload = createUploadFileForm(fileInput, false, {
            name: "faqs/" + this.state._form.id,
            bucket_type: "faq_assets",
          });
          this.props.uploadImage(tempPayload, nextImageUpload[0]);
        }
        this.setState({
          _images,
          _imageUploadList: this.state._imageUploadList.filter(
            ({ identifier }) => identifier !== getIdentifier
          ),
          _taskDone: count,
        });
      }
    }
  };

  /**
   * Handle to change local state from input uset like textfield
   * @author haikal
   * @param {event} e
   */
  handleChange(e) {
    const newState = { ...this.state._form };
    newState[e.target.name] = e.target.value;
    this.setState({ _form: newState });
  }
  handleCheckedChange(e) {
    const newState = { ...this.state._form };
    newState[e.target.name] = e.target.checked;
    this.setState({ _form: newState });
  }
  onSelectChange(val, attributeForm) {
    const { _form } = this.state;
    if (val && val.id) {
      _form[attributeForm] = val;
      _form["faq_category_id"] = val.id;
    }
    else {
      if(val){
        _form[attributeForm] = val;
        _form["language"] = val.value;
      }
    }
    this.setState({ _form });
  }
  onSubmit(e) {
    e.preventDefault();
    this.setState({ _formSubmit: true }, () => {
      const {
        id,
        question,
        answer,
        faq_category_id,
        language,
        active,
      } = this.state._form;
      const language_code = language ? language : 'ind';
      if (this.props.edit && this.state._hasId) {
        this.props.update(id, { question, answer, faq_category_id, active, language_code });
      } else {
        if (
          this.state._images.filter((item) => item.storageName === "in-local")
            .length
        ) {
          const _imageUploadList = this.state._images
            .filter((item) => item.storageName === "in-local")
            .map(({ identifier, fileInput }) => ({ identifier, fileInput }));
          this.setState(
            {
              _imageUploadList,
              _isModalProgress: true,
              _taskAvailable: 1 + _imageUploadList.length,
              _taskDone: 0,
            },
            () =>
              this.props.create({ question, answer, faq_category_id, active, language_code })
          );
        } else this.props.create({ question, answer, faq_category_id, active, language_code });
      }
    });
  }

  _handleDropzoneOnDrop(files, rejectedFiles = []) {
    if (hasUnsupportedImageFiles(files, rejectedFiles)) {
      alert(IMAGE_UPLOAD_ERROR_MESSAGE);
    }

    if (files.length) {
      const { _images } = this.state;
      const droppedImages = files.map((file) => {
        const identifier = uuidv4();
        return {
          id: null,
          url: null,
          storageName: "in-local",
          status: false,
          isUploading: false,
          fileInput: file,
          updatedAt: null,
          identifier,
        };
      });
      const clonedImages = [..._images, ...droppedImages];
      this.setState({ _images: clonedImages });
    }
  }

  _handleRemoveImage(e, imageIdentifier, imageId) {
    e.preventDefault();
    const { _images } = this.state;
    if (imageId) {
      this.setState({
        _images: _images.map((item) =>
          item.identifier === imageIdentifier
            ? { ...item, deleted: true }
            : item
        ),
      });
      this.props.removeImage(imageIdentifier, imageId);
    } else {
      this.setState({
        _images: _images.filter(
          ({ identifier }) => identifier !== imageIdentifier
        ),
      });
    }
  }

  _handleUploadImages = async () => {
    const { _images, _imageUploadProgress } = this.state;
    const notUploadedImages = _images.filter((item) => item.id === null);
    if (!_imageUploadProgress && notUploadedImages.length) {
      const firstImage = notUploadedImages[0];
      let fileInput;

      try {
        //compress file
        fileInput = await ImagesCompressor(firstImage.fileInput);
      } catch (e) {
        fileInput = firstImage.fileInput;
      }

      const newImages = _images.map((item) => {
        if (item.identifier == firstImage.identifier) {
          return {
            ...item,
            is_uploading: true,
          };
        }
        return {
          ...item,
        };
      });
      this.setState({
        _images: newImages,
        _imageUploadProgress: !_imageUploadProgress,
        _imageUploadList: notUploadedImages.map((item) => item.identifier),
      });
      const tempPayload = createUploadFileForm(fileInput, false, {
        name: "faqs/" + this.state._form.id,
        bucket_type: "faq_assets",
      });
      this.props.uploadImage(tempPayload, firstImage);
    }
  };

  handleChangeEditor(data) {
    this.setState({
      _form: {
        ...this.state._form,
        answer: data,
      },
    });
  }

  bindFaqImageData = (imagesProps) => {
    return imagesProps.map((image) => ({
      identifier: uuidv4(),
      id: image.id,
      position: image.position,
      storageName: getStorageName(image.URL),
      urlKey: getUrlKey(image.URL),
      url: image.URL,
      updated_at: image.updated_at,
      status: true,
      is_uploading: false,
    }));
  };

  renderLoading() {
    return (
      <div className="row">
        <div className="col-sm-12">
          <Alert color="info" className="text-center">
            Getting all data...
          </Alert>
        </div>
      </div>
    );
  }
  renderInfo() {
    let infoMessage = [];
    if (this.props.faq.isSubmit)
      infoMessage.push(
        <Alert color="info" key="info">
          <strong>Heads up!</strong> Submitting...
        </Alert>
      );
    if (this.props.faq.success)
      infoMessage.push(
        <Alert color="success" key="success">
          <strong>Well done!</strong> {this.props.faq.success}
        </Alert>
      );
    if (this.props.faq.error !== null) {
      const { status_code } = this.props.faq.error;
      switch (status_code) {
        case 422:
          infoMessage.push(
            <Alert color="danger" key="error">
              <strong>Oh Snap!</strong> Please fullfill your form.{" "}
            </Alert>
          );
          break;
        case 404:
          infoMessage.push(
            <Alert color="danger" key="error">
              <strong>Oh Snap!</strong> Resource not found.{" "}
            </Alert>
          );
          break;
        default:
          infoMessage.push(
            <Alert color="danger" key="error">
              <strong>Oh Snap!</strong> We've got something errors{" "}
            </Alert>
          );
          break;
      }
    }
    return (
      <div className="row">
        <div className="col-sm-12">{infoMessage}</div>
      </div>
    );
  }

  validateError(name) {
    if (this.hasError(name)) {
      let errorList = this.props.faq.error.errors;
      return <ValidationMessage message={errorList[name][0]} />;
    }
    return "";
  }

  hasError(name) {
    if (this.props.faq.error) {
      if (this.props.faq.error.errors) {
        let errorList = this.props.faq.error.errors;
        let errList = Object.keys(errorList).filter((key) => key == name);
        if (errList.length) return true;
      }
    }
    return false;
  }

  toggle() {
    this.setState({ _modalDelete: !this.state._modalDelete });
  }

  onDelete() {
    const _assetsToDelete = this.state._images.filter(
      (item) => item.urlKey !== ""
    );
    this.setState(
      {
        _formSubmit: true,
        _isDeleting: true,
        _modalDelete: false,
        _modalDeleteProgressOpen: true,
        _faqDeleteProgress: true,
        _taskAvailable: 1 + _assetsToDelete.length,
        _taskDone: 0,
        _assetsToDelete,
      },
      () => {
        this.props.delete(this.state._form.id);
      }
    );
  }

  render() {
    return (
      <Row>
        <ModalProgress
          isDeleting={this.state._isDeleting}
          isOpen={
            this.state._isModalProgress || this.state._modalDeleteProgressOpen
          }
          renderModalBody={() =>
            this.state._isDeleting ? (
              <p className="text-center">
                {this.state._taskAvailable > this.state._taskDone
                  ? "Deleting..."
                  : this.state._taskAvailable > 0
                  ? "Delete successfully..."
                  : "Not available..."}{" "}
                ({this.state._taskDone}/{this.state._taskAvailable})
              </p>
            ) : (
              <p className="text-center">
                {this.state._taskAvailable > this.state._taskDone
                  ? "Please waiting..."
                  : this.state._taskAvailable > 0
                  ? "Submit successfully..."
                  : "Not available..."}{" "}
                ({this.state._taskDone}/{this.state._taskAvailable})
              </p>
            )
          }
          isPrimaryButtonHide={this.state._taskAvailable > this.state._taskDone}
          onPrimaryClick={() =>
            this.state._isDeleting
              ? this.props.history.replace(`/faqs`)
              : this.props.history.replace(`/faqs/${this.state._form.id}`)
          }
        />
        <Modal
          isOpen={this.state._modalDelete}
          toggle={this.toggle.bind(this)}
          className="modal-dialog modal-sm"
        >
          <ModalHeader toggle={this.toggle.bind(this)}>
            Confirmation
          </ModalHeader>
          <ModalBody>
            {this.state._modalDelete && this.props.faq.isSubmit ? (
              <div className="row">
                <div className="col-sm-12">
                  <Alert color="info" className="text-center">
                    Deleting...
                  </Alert>
                </div>
              </div>
            ) : (
              <span>Are you sure to delete this?</span>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.onDelete.bind(this)}>
              Yes
            </Button>{" "}
            <Button color="secondary" onClick={this.toggle.bind(this)}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
        <div className="col-lg-7">
          <Card>
            <CardHeader>
              <i className="fa fa-align-justify"></i> {this.props.title}
            </CardHeader>
            <CardBody>
              {this.renderInfo()}
              {this.props.faq.isFetch ? (
                this.renderLoading()
              ) : (
                <Form onSubmit={this.onSubmit}>
                  <FormGroup
                    className={
                      this.hasError("question")
                        ? " has-danger has-feedback"
                        : ""
                    }
                  >
                    <Label for="formQuestion">Question</Label>
                    <Input
                      type="text"
                      id="formQuestion"
                      name="question"
                      placeholder="Enter a question*"
                      value={this.state._form.question}
                      onChange={this.handleChange.bind(this)}
                    />
                    {this.validateError("question")}
                  </FormGroup>
                  <FormGroup
                    className={
                      this.hasError("faq_category_id")
                        ? " has-danger has-feedback"
                        : ""
                    }
                  >
                    <Label for="formFaqCategory">FAQ Category</Label>
                    <SelectFaqCategory
                      id="formFaqCategory"
                      name="faq_category_id"
                      defaultOptions
                      ref="selectFaqCategory"
                      paramsApi={{ sort_by: "createdAt_desc" }}
                      placeholder="Select a category..."
                      noResultsText="Cannot find faq category."
                      value={this.state._form.faq_category || null}
                      onSelectChange={(val) => {
                        this.onSelectChange(val, "faq_category");
                      }}
                    />
                    {this.validateError("faq_category_id")}
                  </FormGroup>
                  <FormGroup className={classNames({ 'has-danger has-feedback': this.hasError('language_code') })}>
                    <Label>Language</Label>
                    <Select
                      name="language_code"
                      value={textValue('language_code', this.state._form)}
                      options={languageOptions}
                      onChange={val => this.onSelectChange(val, 'language_code')}
                    />
                    { this.validateError('language_code') }
                  </FormGroup>
                  <FormGroup
                    className={classNames({
                      "has-danger has-feedback": hasError(
                        "active",
                        this.state._error
                      ),
                    })}
                  >
                    <Label for="formFaqActive">Set to Active &nbsp;</Label>
                    <label className="switch switch-text switch-success-outline-alt">
                      <input
                        type="checkbox"
                        className="switch-input"
                        name="active"
                        id="formFaqActive"
                        value="true"
                        checked={textValue("active", this.state._form)}
                        onChange={this.handleCheckedChange}
                      />
                      <span
                        className="switch-label"
                        data-on="On"
                        data-off="Off"
                      ></span>
                      <span className="switch-handle"></span>
                    </label>
                    {this.validateError("active")}
                  </FormGroup>
                  <FormGroup
                    className={
                      this.hasError("answer") ? " has-danger has-feedback" : ""
                    }
                  >
                    <Label for="formFaqAnswer">Answer</Label>
                    {this.state._edit ? (
                      this.state._form.answer !== "" ||
                      this.state._form.binding ? (
                        <RichTextEditor
                          handleChange={this.handleChangeEditor}
                          value={this.state._form.answer}
                        />
                      ) : null
                    ) : (
                      <RichTextEditor
                        handleChange={this.handleChangeEditor}
                        value={this.state._form.answer}
                      />
                    )}
                    {this.validateError("answer")}
                  </FormGroup>
                  {!this.state._hasId && (
                    <FormGroup>
                      <UploadImages
                        accept={IMAGE_ACCEPT}
                        onDrop={this._handleDropzoneOnDrop}
                        images={this.state._images}
                        onRemoveImage={this._handleRemoveImage}
                      />
                    </FormGroup>
                  )}
                  <FormGroup>
                    <ButtonGroup>
                      <Button
                        color="primary"
                        disabled={this.props.faq.isSubmit}
                      >
                        Submit
                      </Button>
                      {this.state._hasId ? (
                        <Button
                          color="danger"
                          onClick={this.toggle.bind(this)}
                          disabled={this.props.faq.isSubmit}
                        >
                          Delete
                        </Button>
                      ) : (
                        ""
                      )}
                    </ButtonGroup>
                  </FormGroup>
                </Form>
              )}
            </CardBody>
          </Card>
        </div>
        <div className="col-lg-5">
          <FaqCategoryIndex {...this.props} />
        </div>
        {this.state._hasId && (
          <FaqImages
            isLoading={
              this.props.faq.isFetch ||
              this.props.faq.detail.status_code !== 200
            }
            isShow={this.state._edit}
            images={this.state._images}
            accept={IMAGE_ACCEPT}
            onDrop={this._handleDropzoneOnDrop}
            onRemoveImage={this._handleRemoveImage}
            onUploadImages={this._handleUploadImages}
          />
        )}
      </Row>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    faq: state.faq,
    imageUpload: state.imageUpload,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    find: (id) => dispatch(getDetailFaq(id)),
    delete: (id) => dispatch(deleteFaq(id)),
    update: (id, payload) => dispatch(updateFaq(id, payload)),
    create: (payload) => dispatch(createFaq(payload)),
    clearImageUpload: () => dispatch(clearImageUpload()),
    uploadImage: (payload, rawImages) =>
      dispatch(uploadImage(payload, rawImages)),
    saveImage: (identifier, payload) => dispatch(addImage(identifier, payload)),
    removeImage: (identifierImg, id) =>
      dispatch(deleteImage(identifierImg, id)),
    deleteImageS3: (payload) => dispatch(deleteImageS3(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(FaqForm);
